import { Text, Flex } from "@chakra-ui/react";
import { formatDateToISO } from "@root/utils/date-helper";
import React from "react";
import { useTranslation } from "react-i18next";

const CertificateSectionDesc: React.FC<any> = ({ course }) => {
  const { t } = useTranslation("common");

  return (
    <Flex
      maxW="520.11px" // Max width constraint on large screens
      w="350px" // Full width on smaller screens
      h="100%"
      flexDirection="column"
      justifyContent="space-between"
      alignItems={["center", "flex-start"]}
      p="4px"
      gap="8px"
      borderRadius="12px"
    >
      <Text
        fontFamily="Poppins"
        fontWeight="600"
        fontSize={["14px", "16px"]}
        lineHeight="100%"
        color="#2F2F34"
        textAlign={["center", "left"]}
      >
        {course?.title}
      </Text>

      <Text
        fontSize={["12px", "14px"]}
        color="#5C6670"
        fontWeight="400"
        fontFamily="Poppins"
        textAlign={["center", "left"]}
      >
        {t("certificateSection.completed")}:{" "}
        {formatDateToISO(course?.updatedAt)}
      </Text>

      <Text
        fontSize={["12px", "14px"]}
        color="#5C6670"
        fontWeight="400"
        fontFamily="Poppins"
        textAlign={["center", "left"]}
      >
        {t("certificateSection.CompletionCertificate")}
      </Text>
    </Flex>
  );
};

export default CertificateSectionDesc;
